import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["baseUrl", "icon", "subMenu"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/IconMenu.js",
  _this = this;
import React, { useState } from 'react';
import useDevice from '../../core/hooks/useDevice';
import Text from '../Text';
import Column from '../Column';
import { testIdProps } from '../../helpers';
import { withTheme } from '../../core/ThemeProvider';
import styled, { css } from 'styled-components';
import { remCalc } from '@lux/helpers';
var StyledIconMenuContainer = styled.div.withConfig({
  displayName: "IconMenu__StyledIconMenuContainer",
  componentId: "sc-bc4tn4-0"
})(["position:relative;"]);
var StyledIconAnchor = withTheme(styled(Text).withConfig({
  displayName: "IconMenu__StyledIconAnchor",
  componentId: "sc-bc4tn4-1"
})(function (props) {
  return css(["display:flex;.hover{display:none;}svg{height:", ";margin-left:", ";@media (min-width:", "){height:", ";margin-left:0;}}", ""], props.coreTheme.header.mobileIconHeight, remCalc(16), props.coreTheme.brk_md, props.coreTheme.header.deskTopIconHeight, props.handleHover && css(["&:hover{svg,img{display:none;}.hover{display:block;}}"]));
}));
var StyledIconImgDesktop = withTheme(styled.img.withConfig({
  displayName: "IconMenu__StyledIconImgDesktop",
  componentId: "sc-bc4tn4-2"
})(function (props) {
  return css(["height:", ";width:", ";"], props.coreTheme.header.deskTopIconHeight, props.coreTheme.header.deskTopIconWidth);
}));
var StyledIconImgMobile = withTheme(styled.img.withConfig({
  displayName: "IconMenu__StyledIconImgMobile",
  componentId: "sc-bc4tn4-3"
})(function (props) {
  return css(["margin-left:", ";height:", ";width:", ";"], remCalc(16), props.coreTheme.header.mobileIconHeight, props.coreTheme.header.mobileIconWidth);
}));
var IconSubMenuContainer = withTheme(styled.div.withConfig({
  displayName: "IconMenu__IconSubMenuContainer",
  componentId: "sc-bc4tn4-4"
})(function (props) {
  return css(["position:absolute;top:", ";@media (min-width:", "){top:", ";}right:", ";width:", ";border:", " solid ", ";border-radius:", ";margin-top:", ";box-shadow:", ";z-index:9999;overflow-x:visible;&::before{position:absolute;top:", ";right:", ";content:'';border-style:solid;border-color:transparent transparent ", " transparent;border-width:0 ", " ", " ", ";}"], remCalc(24), props.coreTheme.brk_md, remCalc(40), remCalc(-15), remCalc(180), remCalc(2), props.coreTheme.cl_ter_l5, remCalc(3), remCalc(12), props.coreTheme.sd_size_1, remCalc(-10), remCalc(20), props.coreTheme.cl_ter_l5, remCalc(10), remCalc(10), remCalc(10));
}));
var IconSubMenuList = withTheme(styled.ul.withConfig({
  displayName: "IconMenu__IconSubMenuList",
  componentId: "sc-bc4tn4-5"
})(function (props) {
  return css(["display:block;list-style-type:none;background:", ";overflow:hidden;margin:0;padding-left:0;z-index:9;&::before{position:absolute;top:", ";right:", ";content:'';border-style:solid;border-color:transparent transparent ", " transparent;border-width:0 ", " ", " ", ";}"], props.coreTheme.cl_white, remCalc(-8), remCalc(22), props.coreTheme.cl_white, remCalc(8), remCalc(8), remCalc(8));
}));
var IconSubMenuListItem = withTheme(styled.li.withConfig({
  displayName: "IconMenu__IconSubMenuListItem",
  componentId: "sc-bc4tn4-6"
})(function (props) {
  return css(["&:hover{background:", ";}"], props.coreTheme.cl_ter_l5);
}));
var IconSubMenuListItemAnchor = withTheme(styled(Text).withConfig({
  displayName: "IconMenu__IconSubMenuListItemAnchor",
  componentId: "sc-bc4tn4-7"
})(function (props) {
  return css(["display:block;padding:", " ", ";font-family:", ";font-size:", ";color:", ";&:not([disabled]):hover{color:", ";}"], remCalc(9), remCalc(20), props.coreTheme.header.iconMenuFont, props.coreTheme.fs_md, props.coreTheme.header.iconMenuFontColor, props.coreTheme.header.iconMenuActiveFontColor);
}));
var CartCount = withTheme(styled.span.withConfig({
  displayName: "IconMenu__CartCount",
  componentId: "sc-bc4tn4-8"
})(function (props) {
  return css(["color:", ";height:1rem;min-width:1rem;font-size:0.625rem;border-radius:0.5rem;background-color:", ";position:absolute;z-index:1;display:inline-block;right:0;text-align:center;margin:-6px -6px 0 0;@media (min-width:", "){margin:0;}"], props.coreTheme.cl_white, props.coreTheme.cl_pri_base, props.coreTheme.brk_md);
}));
var ResponsiveColumn = withTheme(styled(Column).withConfig({
  displayName: "IconMenu__ResponsiveColumn",
  componentId: "sc-bc4tn4-9"
})(function (props) {
  return css(["height:", ";"], props.mobile ? props.coreTheme.header.mobileIconHeight : props.coreTheme.header.deskTopIconHeight);
}));
var IconMenu = function IconMenu(_ref) {
  var baseUrl = _ref.baseUrl,
    icon = _ref.icon,
    subMenu = _ref.subMenu,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useDevice = useDevice(),
    isMobile = _useDevice.isMobile,
    isTablet = _useDevice.isTablet,
    isLandscapeTablet = _useDevice.isLandscapeTablet;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMenuOpen = _useState2[0],
    setIsMenuOpen = _useState2[1];
  var handleClick = function handleClick() {
    return setIsMenuOpen(!isMenuOpen);
  };
  var renderIcon = function renderIcon() {
    var MobileIcon = icon.mobile ? icon.mobile : icon.desktop;
    var DesktopIcon = icon.desktop;
    var DesktopHoverIcon = icon.desktopHover;
    var desktopIcon = null;
    var desktopHoverIcon = null;
    var mobileIcon = null;
    if (DesktopIcon) {
      if (typeof DesktopIcon === 'string') {
        desktopIcon = /*#__PURE__*/React.createElement(StyledIconImgDesktop, {
          "data-testid": "desktop-icon",
          src: DesktopIcon,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 202,
            columnNumber: 11
          }
        });
      } else {
        desktopIcon = /*#__PURE__*/React.createElement(DesktopIcon, {
          "data-testid": "desktop-svg-icon",
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 205,
            columnNumber: 23
          }
        });
      }
    }
    if (DesktopHoverIcon) {
      if (typeof DesktopHoverIcon === 'string') {
        desktopHoverIcon = /*#__PURE__*/React.createElement(StyledIconImgDesktop, {
          src: DesktopHoverIcon,
          className: "hover",
          "data-testid": "desktop-icon-hover",
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 212,
            columnNumber: 11
          }
        });
      } else {
        desktopHoverIcon = /*#__PURE__*/React.createElement(DesktopHoverIcon, {
          className: "hover",
          "data-testid": "desktop-svg-icon-hover",
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 220,
            columnNumber: 11
          }
        });
      }
    }
    if (MobileIcon) {
      if (typeof MobileIcon === 'string') {
        mobileIcon = /*#__PURE__*/React.createElement(StyledIconImgMobile, {
          src: MobileIcon,
          "data-testid": "mobile-icon",
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 231,
            columnNumber: 11
          }
        });
      } else {
        mobileIcon = /*#__PURE__*/React.createElement(MobileIcon, {
          "data-testid": "mobile-svg-icon",
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 234,
            columnNumber: 22
          }
        });
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResponsiveColumn, {
      noGutter: true,
      xs: false,
      lg: 12,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 240,
        columnNumber: 9
      }
    }, desktopIcon, desktopHoverIcon), /*#__PURE__*/React.createElement(ResponsiveColumn, {
      noGutter: true,
      mobile: true,
      xs: 12,
      lg: false,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 244,
        columnNumber: 9
      }
    }, mobileIcon));
  };
  return /*#__PURE__*/React.createElement(StyledIconMenuContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(StyledIconAnchor, _extends({
    type: "link",
    href: icon.href && "".concat(baseUrl).concat(icon.href),
    onClick: subMenu ? handleClick : icon.onClick
  }, testIdProps(rest), {
    handleHover: !(isMobile || isTablet || isLandscapeTablet) && icon.desktopHover,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 253,
      columnNumber: 7
    }
  }), icon.cartItemCount >= 0 && /*#__PURE__*/React.createElement(CartCount, {
    "data-testid": "cart-count",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 263,
      columnNumber: 11
    }
  }, icon.cartItemCount), renderIcon()), subMenu && isMenuOpen && /*#__PURE__*/React.createElement(IconSubMenuContainer, {
    "data-testid": "icon-sub-menu",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 268,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconSubMenuList, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 269,
      columnNumber: 11
    }
  }, subMenu.map(function (menu, key) {
    return /*#__PURE__*/React.createElement(IconSubMenuListItem, {
      key: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 271,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(IconSubMenuListItemAnchor, {
      type: "link",
      href: menu.href && "".concat(baseUrl).concat(menu.href),
      onClick: menu.onClick,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 272,
        columnNumber: 17
      }
    }, menu.title));
  }))));
};
export default IconMenu;